import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import jsonp from 'jsonp';
import { useState } from 'react';
import toQueryString from 'to-querystring';

var postFormData = function postFormData(data) {
  return 'TODO';
};

var BASE_URL = "https://<dc>.api.mailchimp.com/3.0";

var getURL = function getURL(url) {
  return url.replace('/post?', '/post-json?');
};

var isResponseIsError = function isResponseIsError(response) {
  return response.result !== 'success';
};

var getDefaultState = function getDefaultState() {
  return {
    error: null,
    loading: false,
    data: null
  };
};

export default function useMailchimp(_ref) {
  var url = _ref.url;

  var _useState = useState(getDefaultState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var reset = function reset() {
    setState(getDefaultState());
  };

  var subscribe = function subscribe(data) {
    var params = toQueryString(data);
    var requestURL = getURL(url) + '&' + params;
    var requestOpts = {
      param: 'c',
      timeout: 4000
    };
    setState({
      loading: true,
      error: null,
      data: null
    });

    var process = function process(error, response) {
      if (error) {
        setState({
          loading: false,
          error: error,
          data: response
        });
        return;
      }

      if (isResponseIsError(response)) {
        setState({
          loading: false,
          error: new Error(response.msg),
          data: response
        });
        return;
      }

      setState({
        loading: false,
        error: null,
        data: response
      });
    };

    jsonp(requestURL, requestOpts, process);
  };

  return [state, subscribe, reset];
}